import React, { Component } from 'react';
import PageLayout from '../../layouts/pagelayout';
import SectionTitle from '../../components/section-title';
import CustomImage from '../../components/custom-image';
import BreadCrumb from '../../components/breadcrumb';
import CommunityDevelopment from '../../layouts/social-development/community-development';
import Casestudy1 from '../../layouts/social-development/casestudy-1';
import Casestudy2 from '../../layouts/social-development/casestudy-2';
import Casestudy3 from '../../layouts/social-development/casestudy-3';
import Collapse from '../../components/collapse';
import ScrollPositionAnimation from '../../components/scrollpositionanimation';

const SocialDevelopment = () => {
  return (
    <PageLayout pageTitle="Vedanta - Social Focus" pageLink="/sustainability-and-esg/social-focus">
      <div className="social-development">
        <BreadCrumb />
        <div className="container-fluid p-t-0 remove-gradient">
          <div className="social-development-container top-section">
            <ScrollPositionAnimation targetElement1="anim-one" targetElement2="anim-two">
              <div className="section-inner">
                <div className="left-img">
                  <div className="desktop-img left-to-right anim-one">
                    <CustomImage imageName="social-focus.jpg" alt="social focus" maxWidth="680" />
                  </div>
                  <div className="mobile-img">
                    <CustomImage imageName="social-foucs-mobile-img.jpg" alt="social focus" maxWidth="991" />
                  </div>
                </div>
                <div className="right-content bottom-to-top anim-two">
                  <SectionTitle
                    label="SOCIAL FOCUS"
                    lighttext="EMPOWERING"
                    boldtext="COMMUNITIES FOR INCLUSIVE GROWTH"
                    iconimage="social-icon-hands.png"
                  ></SectionTitle>
                  <p className="blue-text">
                    Retaining the trust of our host communities is central to our ability to do business. In many
                    instances, we are the primary economic driver where we operate. This places us in a unique position
                    to signiﬁcantly impact the lives of local communities, whether as employers and business partners or
                    through our community development interventions. We take this responsibility seriously and endeavour
                    to fulﬁl our role in a manner that upholds the dignity of all our stakeholders and allows us to live
                    up to our values.
                  </p>
                  <Collapse labelOne="Read More" labelTwo="Read Less">
                    <p className="blue-text">
                      The Vedanta Sustainability Framework and its associated standards and policies guide our work on
                      social performance. In areas with indigenous populations, we are committed to following the
                      principles of Free, Prior, Informed Consent (FPIC). With its genesis in the UN Declarations of
                      Rights of Indigenous Peoples, it has been adopted as a best practice by the IFC and ICMM.
                    </p>

                    <p className="blue-text">
                      Our CSR Council, led by a senior business leader, and including CSR Heads and CSR Executives from
                      all business units, meets every month and reviews the performance, spends and outcome of CSR
                      programmes across units. Governed by our in-house CSR Policy and Sustainability Framework, the
                      Council is responsible for governance, synergy and cross-learning across the Group CSR efforts.
                      The Board CSR Committee comprises senior Independent Directors; and apart from providing strategic
                      direction for CSR activities, it also approves plans and budgets, and reviews progress of the
                      initiatives.
                    </p>
                  </Collapse>
                </div>
              </div>
            </ScrollPositionAnimation>
          </div>
        </div>
        <div className="container-fluid p-b-0">
          <div className="social-development-container bottom-section">
            <ScrollPositionAnimation targetElement1="anim-three" targetElement2="anim-four">
              <div className="section-inner other-section">
                <div className="left-content bottom-to-top anim-four">
                  <h3 className="bold-text blue-text text-width">PERFORMANCE &amp; SOCIAL LICENCE TO OPERATE</h3>
                  <div className="mobile-img">
                    <CustomImage
                      imageName="performance-and-social-licenced-to-perform-mobile.png"
                      alt="deeps plant"
                      maxwidth="360"
                    />
                  </div>
                  <p>
                    Securing and retaining one’s social licence to operate is an outcome resulting from a Company’s
                    ability to garner the trust of the communities where it operates. Social performance frameworks are
                    a good mechanism to measure, manage, and monitor this aspect of the business.
                  </p>
                  <p>
                    In FY2020, we took the first steps to developing a holistic approach to improving our social
                    performance. Taking help from experts in this Access to affordable and quality healthcare field,
                    Vedanta conducted a cross-BU review of the maturity of our businesses with respect to the social
                    performance framework. Additionally, perception surveys were also conducted at our key locations to
                    understand the viewpoints of our local stakeholders. Learnings from both these exercises are being
                    studied and in FY2021, we will be conducting a year-long social performance pilot programme at two
                    of our operational sites to evolve our social performance approach.
                  </p>

                  <h3 className="bold-text blue-text title-spacing">COMMUNITY DEVELOPMENT PROGRAMMES</h3>
                  <p>
                    Vedanta has one of the most extensive community development programmes in the country. During
                    FY2020, we spent ₹288 crores to help communities enhance their quality of life through various
                    interventions. An overview of these programmes is given below.
                  </p>
                </div>
                <div className="right-img">
                  <div className="desktop-img right-to-left anim-three">
                    <CustomImage
                      imageName="performance-and-social-licenced-to-perform.png"
                      alt="deeps plant"
                      maxwidth="608"
                    />
                  </div>
                </div>
              </div>
            </ScrollPositionAnimation>
          </div>
        </div>
        <CommunityDevelopment />
        <Casestudy1 />
        <Casestudy2 />
        <Casestudy3 />
      </div>
    </PageLayout>
  );
};

export default SocialDevelopment;
